<template>
  <div class="owner-selector">
    <el-select
      v-if="showType"
      :value="currentOwnerType"
      :disabled="disabled || typeDisabled"
      :size="size"
      :style="{ width: typeWidth }"
      placeholder="归属类型"
      @input="handleTypeInput"
    >
      <el-option label="个人" value="PERSONAL"></el-option>
      <el-option label="组织" value="ORGANIZATION"></el-option>
    </el-select>
    <account-selector
      v-if="currentOwnerType === 'PERSONAL'"
      :value="value"
      :disabled="disabled || idDisabled"
      :size="size"
      :clearable="clearable"
      :placeholder="personalPlaceholder"
      :style="{ flex: 1, minWidth: idMinWidth }"
      @input="handleOwnerIdInput"
      @change="handleEntityChange"
    ></account-selector>
    <organization-selector
      v-else
      :value="value"
      :disabled="disabled || idDisabled"
      :size="size"
      :clearable="clearable"
      :placeholder="organizationPlaceholder"
      :style="{ flex: 1, minWidth: idMinWidth }"
      @input="handleOwnerIdInput"
      @change="handleEntityChange"
    ></organization-selector>
  </div>
</template>

<script>
import AccountSelector from './AccountSelector.vue'
import OrganizationSelector from './OrganizationSelector.vue'

export default {
  name: 'AiOwnerSelector',
  components: {
    AccountSelector,
    OrganizationSelector
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    ownerType: {
      type: String,
      default: 'PERSONAL'
    },
    size: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    typeDisabled: {
      type: Boolean,
      default: false
    },
    idDisabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    showType: {
      type: Boolean,
      default: true
    },
    typeWidth: {
      type: String,
      default: '140px'
    },
    idMinWidth: {
      type: String,
      default: '240px'
    },
    personalPlaceholder: {
      type: String,
      default: '请选择个人账户'
    },
    organizationPlaceholder: {
      type: String,
      default: '请选择组织'
    }
  },
  computed: {
    currentOwnerType () {
      return this.ownerType === 'ORGANIZATION' ? 'ORGANIZATION' : 'PERSONAL'
    }
  },
  methods: {
    handleTypeInput (type) {
      const nextType = type || 'PERSONAL'
      if (nextType !== this.currentOwnerType) {
        this.$emit('input', '')
        this.$emit('change', null)
      }
      this.$emit('update:ownerType', nextType)
    },
    handleOwnerIdInput (value) {
      this.$emit('input', value || '')
    },
    handleEntityChange (entity) {
      this.$emit('change', entity)
    }
  }
}
</script>

<style scoped>
.owner-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
</style>
